/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {COLORS} from "@res/colors";
import * as React from "react";

export const InPlaceLoader = ({loading}: { loading?: boolean }) => {
    return <div className={'absolute top left fill'} style={{...!loading && {display: 'none'}, zIndex: 9999}}>
        <div className={'absolute top left fill'} style={{backgroundColor: COLORS.neutral_gray_2, opacity: 0.2}}/>
        <div className={'absolute top left right bottom center_h center_v'} style={{width: 'fit-content', height: 'fit-content'}}>
            <div className={`loader`} style={{margin: 0, transform: 'translate(-50%, -50%)'}}/>
        </div>
    </div>;
};
